import styled from "styled-components";

export const StyledTag = styled.div`
  margin-left: 2rem;
  h4 {
    color: rgba(8, 8, 43, 0.35);
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.2rem;
    font-style: normal;
    font-weight: bold;
  }
`;

export const ButtonContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
  width: 100%;
  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
  }
`;

export const MainButton = styled.button`
  ${(props) => `
  background-color: ${props.theme.colors.accentGreen};
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  font-family: ${props.theme.fontFamilies.primaryFont};
`}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  min-height: 6.4rem;
  width: 34.8rem;
`;

export const SearchErrorDetail = styled.div`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  column-gap: 1.5rem;
  display: flex;
  font-size: 1.4rem;
  font-weight: 500;
  margin-left: 2rem;
  margin-right: 3rem;
  padding: 1rem 2rem;
`;

export const InstructionsLabel = styled.p`
  margin-left: 1rem;
  font-size: 1.4rem;
  font-weight: 500;
`;

export const DivMessage = styled.div`
  background: #fff8da;
  display: flex;
  height: 4.4rem;
  margin-right: 14rem;
  margin: 2.2rem;

  .align-div-flex {
    align-items: center;
    display: flex;
    margin-left: 2rem;
  }
  .iconimage {
    height: 2rem;
    width: 2rem;
  }
`;
